var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.mixes),function(mix,index){return _c('ShowTableTile',{key:mix.id + index + new Date(),attrs:{"mix":mix,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }